import React from 'react';
import '../css/App.css';
import Loading from "./Loading";
import TopNav from "./TopNav";
import {isMobile} from 'react-device-detect';
import ls from "local-storage";
class AppBody extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            loading:false,
            fontSize:ls.get("fontSize")
        };
    }
    componentWillMount() {
        if(ls.get("fontSize") == null)
            ls.set("fontSize",3);
    }

    render() {
        let font = "size3";
        switch (this.state.fontSize) {
            case 1:font = "size1";break;
            case 2:font = "size2";break;
            case 3:font = "size3";break;
            case 4:font = "size4";break;
            case 5:font = "size5";break;
            default:font = "size3";break;
        }

        let style = {paddingTop:"4px"};
        if(this.props.hasSlider != null && this.props.hasSlider== true)
            style = {paddingTop:"0"};
        if(isMobile){
            return (
                <div className={"App mobile "+font} >
                    <Loading loading={this.state.loading}/>
                    <div className={"App-body"+this.props.type}>
                        <TopNav fontSize={this.state.fontSize} plusFont={this.plusFont} showBotNav={this.props.showBotNav}  minusFont={this.minusFont} name={this.props.name}/>
                        <div className={(this.props.showBotNav!=null && !this.props.showBotNav)?"content floor":"content"} style={style}>
                            {this.props.children}
                        </div>
                        {(this.props.outsideContent != null)?this.props.outsideContent:''}
                    </div>
                </div>
            );
        }


        return (
            <div className={"App "+font}>
                <Loading loading={this.state.loading}/>
                <div className={"App-body"+this.props.type}>
                    <TopNav fontSize={this.state.fontSize} plusFont={this.plusFont} minusFont={this.minusFont} showBotNav={this.props.showBotNav} name={this.props.name}/>
                    <div className={(this.props.showBotNav!=null && !this.props.showBotNav)?"content floor":"content"} style={style}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }

    plusFont =()=>{
        if(this.state.fontSize < 5)
            this.setState({fontSize:(this.state.fontSize)?this.state.fontSize+1:3},()=>{ls.set("fontSize",this.state.fontSize)});
    };
    minusFont =()=>{
        if(this.state.fontSize > 1)
            this.setState({fontSize:(this.state.fontSize)?this.state.fontSize-1:3},()=>{ls.set("fontSize",this.state.fontSize)});
    };

    componentWillReceiveProps(props) {
        this.setState(
            {loading:props.loading})
    }
}



export default AppBody;
